/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'
import strictEqualityImg from 'assets/images/strictEquality.png'
import notStrictEqualityImg from 'assets/images/notStrictEquality.png'

export const _7 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Математические операторы</h2>
    <p className={styles.description}>
      Ничем не отличаются от школьного курса математики. Операторы возвращают значение на место операции. Порядок
      вычисления математических выражений и т. п. это всем привычная алгебра.
    </p>
    <p className={styles.description}>
      Важно запомнить правильное именование составляющих выражения. <code className={styles.code}>+ - * / %</code>
      называются <b>операторами</b>, а то на чем они применяются <b>операндами</b>.
    </p>
    <CopyBlock
      text={`// Операции с числами
const x = 10;
const y = 5;

// Сложение
console.log(x + y); // 15

// Вычитание
console.log(x - y); // 5

// Умножение
console.log(x * y); // 50

// Деление
console.log(x / y); // 2

// Остаток от деления
console.log(x % y); // 0

// Сложение с заменой (есть и для других операторов)
let value = 5;

// Аналогично записи value = value + 10;
value += 10;
console.log(value); // 15`}
      language="js"
      showLineNumbers={false}
      theme={ocean}
    />

    <section className={styles.subsection}>
      <h2 className={styles.h2}>2 - Операторы сравнения</h2>
      <p className={styles.description}>
        Используются для сравнения значений. Результатом своего выполнения возвращают були:{' '}
        <code className={styles.code}>true</code> или <code className={styles.code}>false</code>.
      </p>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <code className={styles.code}>a &gt; b</code> и <code className={styles.code}>a &lt; b</code> - больше/меньше
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>a &gt;= b</code> и <code className={styles.code}>a &lt;= b</code> -
          больше/меньше или равно
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>a == b</code> - равенство
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>a != b</code> - неравенство
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>a === b</code> - строгое равенство
        </li>
        <li className={styles.list__item}>
          <code className={styles.code}>a !== b</code> - строгое неравенство
        </li>
      </ul>
      <CopyBlock
        text={`const x = 5;
const y = 10;
const z = 5;

console.log('x > y:', x > y); // false
console.log('x < y:', x < y); // true
console.log('x < z:', x < z); // false
console.log('x <= z:', x <= z); // true
console.log('x === y:', x === y); // false
console.log('x === z:', x === z); // true
console.log('x !== y:', x !== y); // true
console.log('x !== z:', x !== z); // false
`}
        language="js"
        showLineNumbers={false}
        theme={ocean}
      />
    </section>

    <section className={styles.subsection}>
      <h2 className={styles.h2}>3 - == и ===</h2>
      <p className={styles.description}>
        Всегда используйте строгое равенство <code className={styles.code}>===</code> и строгое неравенство{' '}
        <code className={styles.code}>!==</code>. Операторы <code className={styles.code}>==</code> и{' '}
        <code className={styles.code}>!=</code> выполняют преобразование типов сравниваемых значений, что может привести
        к ошибкам, особенно у начинающих. На изображениях ниже показаны таблицы сравнения значений используя операторы{' '}
        <code className={styles.code}>==</code> и <code className={styles.code}>===</code>.
      </p>
      <p className={styles.description}>
        При использовании <code className={styles.code}>===</code> для проверки равенства, все равно только себе. Перед
        оценкой ничего не преобразуется.
      </p>
      <img className={styles.img} src={strictEqualityImg} alt="strictEqualityImg" />

      <p className={styles.description}>
        При использовании <code className={styles.code}>==</code> для проверки равенства, происходит приведение типов
        операндов.
      </p>
      <img className={styles.img} src={notStrictEqualityImg} alt="notStrictEqualityImg" />
    </section>
  </section>
))
